class CountDown {

    constructor(upTo, container, doneCallback, formatter) {
        this.upTo = new Date((upTo + 2) * 1000);
        if (! this.upTo instanceof Date || isNaN(this.upTo)) {
            this.upTo = CountDown.parseYMDHM(upTo);
        }
        this.container = container;
        this.doneCallback = doneCallback;
        this.interval = setInterval(() => { this.updateTimer() }, 1000);
        this.formatter = formatter;
        this.updateTimer();
    }

    updateTimer() {
        let diff = (this.upTo - (new Date()))/1000;
        if (diff > 0) {
            let formattedTime = this.formatter ? this.formatter(diff) : CountDown.getFormattedTime(diff);
            this.container.html(formattedTime);
        } else {
            this.doneCallback();
            clearInterval(this.interval);
        }
    }

    static getHMSFormat(time) {
        let h = Math.floor(time / 3600);
        let m = Math.floor((time - h*3600) / 60);
        let s = Math.floor(time - h*3600 - m*60);

        if (h < 10) h = "0" + h;
        if (m < 10) m = "0" + m;
        if (s < 10) s = "0" + s;
        return {
            'h': h,
            'm': m,
            's': s
        }
    }

    static getDHMSFormat(time) {
        let d = Math.floor(time / 86400);
        let h = Math.floor((time - d*86400) / 3600);
        let m = Math.floor((time - d*86400 - h*3600) / 60);
        let s = Math.floor(time - d*86400 - h*3600 - m*60);

        if (d < 10) d = "0" + d;
        if (h < 10) h = "0" + h;
        if (m < 10) m = "0" + m;
        if (s < 10) s = "0" + s;
        return {
            'd': d,
            'h': h,
            'm': m,
            's': s
        }
    }

    static getFormattedTime(time) {
        time = CountDown.getHMSFormat(time);
        return `${time.h}:${time.m}:${time.s}`;
    }

    static parseYMDHM(s) {
        var b = s.split(/\D+/);
        return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]||0, b[6]||0));
    }

}

export default CountDown;